export default {
    isLoading: false,
    isCtaDisabled: true,
    selectedAccount: null,
    saveForLater: false,
    editing: null
};
